// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d31371b5772c6786cbbf","655":"6decef30daca020e5cf8"}[chunkId] + ".js";
};